import { Columns } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";

export const MyDealsShortcut = () => {
  const translate = useTranslate();

  return (
    <Button asChild size="lg" className="w-full md:w-auto">
      <Link to="/deals">
        <Columns className="w-5 h-5" />
        {translate("crm.dashboard.my_deals", { _: "Minhas propostas" })}
      </Link>
    </Button>
  );
};
